import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Description`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` property of your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file supports a number
of built-in scripts and their preset life cycle events as well as
arbitrary scripts. These all can be executed by running
`}<inlineCode parentName="p">{`npm run-script <stage>`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm run <stage>`}</inlineCode>{` for short. `}<em parentName="p">{`Pre`}</em>{` and `}<em parentName="p">{`post`}</em>{`
commands with matching names will be run for those as well (e.g. `}<inlineCode parentName="p">{`premyscript`}</inlineCode>{`,
`}<inlineCode parentName="p">{`myscript`}</inlineCode>{`, `}<inlineCode parentName="p">{`postmyscript`}</inlineCode>{`). Scripts from dependencies can be run with
`}<inlineCode parentName="p">{`npm explore <pkg> -- npm run <stage>`}</inlineCode>{`.`}</p>
    <h3>{`Pre & Post Scripts`}</h3>
    <p>{`To create "pre" or "post" scripts for any scripts defined in the
`}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` section of the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, simply create another script
`}<em parentName="p">{`with a matching name`}</em>{` and add "pre" or "post" to the beginning of them.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "scripts": {
    "precompress": "{{ executes BEFORE the \`compress\` script }}",
    "compress": "{{ run command to compress files }}",
    "postcompress": "{{ executes AFTER \`compress\` script }}"
  }
}
`}</code></pre>
    <p>{`In this example `}<inlineCode parentName="p">{`npm run compress`}</inlineCode>{` would execute these scripts as
described.`}</p>
    <h3>{`Life Cycle Scripts`}</h3>
    <p>{`There are some special life cycle scripts that happen only in certain
situations. These scripts happen in addition to the `}<inlineCode parentName="p">{`pre<event>`}</inlineCode>{`, `}<inlineCode parentName="p">{`post<event>`}</inlineCode>{`, and
`}<inlineCode parentName="p">{`<event>`}</inlineCode>{` scripts.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode>{`, `}<inlineCode parentName="li">{`prepublish`}</inlineCode>{`, `}<inlineCode parentName="li">{`prepublishOnly`}</inlineCode>{`, `}<inlineCode parentName="li">{`prepack`}</inlineCode>{`, `}<inlineCode parentName="li">{`postpack`}</inlineCode>{`, `}<inlineCode parentName="li">{`dependencies`}</inlineCode></li>
    </ul>
    <p><strong parentName="p">{`prepare`}</strong>{` (since `}<inlineCode parentName="p">{`npm@4.0.0`}</inlineCode>{`)`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Runs any time before the package is packed, i.e. during `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{`
and `}<inlineCode parentName="p">{`npm pack`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Runs BEFORE the package is packed`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Runs BEFORE the package is published`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Runs on local `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` without any arguments`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Run AFTER `}<inlineCode parentName="p">{`prepublish`}</inlineCode>{`, but BEFORE `}<inlineCode parentName="p">{`prepublishOnly`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`NOTE: If a package being installed through git contains a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{`
script, its `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` will be installed, and
the prepare script will be run, before the package is packaged and
installed.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`As of `}<inlineCode parentName="p">{`npm@7`}</inlineCode>{` these scripts run in the background.
To see the output, run with: `}<inlineCode parentName="p">{`--foreground-scripts`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`prepublish`}</strong>{` (DEPRECATED)`}</p>
    <ul>
      <li parentName="ul">{`Does not run during `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`, but does run during `}<inlineCode parentName="li">{`npm ci`}</inlineCode>{`
and `}<inlineCode parentName="li">{`npm install`}</inlineCode>{`. See below for more info.`}</li>
    </ul>
    <p><strong parentName="p">{`prepublishOnly`}</strong></p>
    <ul>
      <li parentName="ul">{`Runs BEFORE the package is prepared and packed, ONLY on `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`.`}</li>
    </ul>
    <p><strong parentName="p">{`prepack`}</strong></p>
    <ul>
      <li parentName="ul">{`Runs BEFORE a tarball is packed (on "`}<inlineCode parentName="li">{`npm pack`}</inlineCode>{`", "`}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`", and when installing a git dependencies).`}</li>
      <li parentName="ul">{`NOTE: "`}<inlineCode parentName="li">{`npm run pack`}</inlineCode>{`" is NOT the same as "`}<inlineCode parentName="li">{`npm pack`}</inlineCode>{`". "`}<inlineCode parentName="li">{`npm run pack`}</inlineCode>{`" is an arbitrary user defined script name, where as, "`}<inlineCode parentName="li">{`npm pack`}</inlineCode>{`" is a CLI defined command.`}</li>
    </ul>
    <p><strong parentName="p">{`postpack`}</strong></p>
    <ul>
      <li parentName="ul">{`Runs AFTER the tarball has been generated but before it is moved to its final destination (if at all, publish does not save the tarball locally)`}</li>
    </ul>
    <p><strong parentName="p">{`dependencies`}</strong></p>
    <ul>
      <li parentName="ul">{`Runs AFTER any operations that modify the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` directory IF changes occurred.`}</li>
      <li parentName="ul">{`Does NOT run in global mode`}</li>
    </ul>
    <h4>{`Prepare and Prepublish`}</h4>
    <p><strong parentName="p">{`Deprecation Note: prepublish`}</strong></p>
    <p>{`Since `}<inlineCode parentName="p">{`npm@1.1.71`}</inlineCode>{`, the npm CLI has run the `}<inlineCode parentName="p">{`prepublish`}</inlineCode>{` script for both `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`, because it's a convenient way to prepare a package for use (some common use cases are described in the section below).  It has also turned out to be, in practice, `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/10074"
      }}>{`very confusing`}</a>{`.  As of `}<inlineCode parentName="p">{`npm@4.0.0`}</inlineCode>{`, a new event has been introduced, `}<inlineCode parentName="p">{`prepare`}</inlineCode>{`, that preserves this existing behavior. A `}<em parentName="p">{`new`}</em>{` event, `}<inlineCode parentName="p">{`prepublishOnly`}</inlineCode>{` has been added as a transitional strategy to allow users to avoid the confusing behavior of existing npm versions and only run on `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` (for instance, running the tests one last time to ensure they're in good shape).`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/10074"
      }}>{`https://github.com/npm/npm/issues/10074`}</a>{` for a much lengthier justification, with further reading, for this change.`}</p>
    <p><strong parentName="p">{`Use Cases`}</strong></p>
    <p>{`If you need to perform operations on your package before it is used, in a way that is not dependent on the operating system or architecture of the target system, use a `}<inlineCode parentName="p">{`prepublish`}</inlineCode>{` script. This includes tasks such as:`}</p>
    <ul>
      <li parentName="ul">{`Compiling CoffeeScript source code into JavaScript.`}</li>
      <li parentName="ul">{`Creating minified versions of JavaScript source code.`}</li>
      <li parentName="ul">{`Fetching remote resources that your package will use.`}</li>
    </ul>
    <p>{`The advantage of doing these things at `}<inlineCode parentName="p">{`prepublish`}</inlineCode>{` time is that they can be done once, in a single place, thus reducing complexity and variability. Additionally, this means that:`}</p>
    <ul>
      <li parentName="ul">{`You can depend on `}<inlineCode parentName="li">{`coffee-script`}</inlineCode>{` as a `}<inlineCode parentName="li">{`devDependency`}</inlineCode>{`, and thus
your users don't need to have it installed.`}</li>
      <li parentName="ul">{`You don't need to include minifiers in your package, reducing
the size for your users.`}</li>
      <li parentName="ul">{`You don't need to rely on your users having `}<inlineCode parentName="li">{`curl`}</inlineCode>{` or `}<inlineCode parentName="li">{`wget`}</inlineCode>{` or
other system tools on the target machines.`}</li>
    </ul>
    <h4>{`Dependencies`}</h4>
    <p>{`The `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` script is run any time an `}<inlineCode parentName="p">{`npm`}</inlineCode>{` command causes changes to the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory. It is run AFTER the changes have been applied and the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` and `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files have been updated.`}</p>
    <h3>{`Life Cycle Operation Order`}</h3>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-cache"
      }}><inlineCode parentName="a">{`npm cache add`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-ci"
      }}><inlineCode parentName="a">{`npm ci`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`preinstall`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`install`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`postinstall`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`prepublish`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`preprepare`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`prepare`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`postprepare`}</inlineCode></p>
        <p parentName="li">{`These all run after the actual installation of modules into
`}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`, in order, with no internal actions happening in between`}</p>
      </li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-diff"
      }}><inlineCode parentName="a">{`npm diff`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-install"
      }}><inlineCode parentName="a">{`npm install`}</inlineCode></a></h4>
    <p>{`These also run when you run `}<inlineCode parentName="p">{`npm install -g <pkg-name>`}</inlineCode></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`preinstall`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`install`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postinstall`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepublish`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`preprepare`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postprepare`}</inlineCode></li>
    </ul>
    <p>{`If there is a `}<inlineCode parentName="p">{`binding.gyp`}</inlineCode>{` file in the root of your package and you
haven't defined your own `}<inlineCode parentName="p">{`install`}</inlineCode>{` or `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{` scripts, npm will
default the `}<inlineCode parentName="p">{`install`}</inlineCode>{` command to compile using node-gyp via `}<inlineCode parentName="p">{`node-gyp
rebuild`}</inlineCode></p>
    <p>{`These are run from the scripts of `}<inlineCode parentName="p">{`<pkg-name>`}</inlineCode></p>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-pack"
      }}><inlineCode parentName="a">{`npm pack`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prepack`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postpack`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-publish"
      }}><inlineCode parentName="a">{`npm publish`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prepublishOnly`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepack`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postpack`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`publish`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postpublish`}</inlineCode></li>
    </ul>
    <p><inlineCode parentName="p">{`prepare`}</inlineCode>{` will not run during `}<inlineCode parentName="p">{`--dry-run`}</inlineCode></p>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-rebuild"
      }}><inlineCode parentName="a">{`npm rebuild`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`preinstall`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`install`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postinstall`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`prepare`}</inlineCode></li>
    </ul>
    <p><inlineCode parentName="p">{`prepare`}</inlineCode>{` is only run if the current directory is a symlink (e.g. with
linked packages)`}</p>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-restart"
      }}><inlineCode parentName="a">{`npm restart`}</inlineCode></a></h4>
    <p>{`If there is a `}<inlineCode parentName="p">{`restart`}</inlineCode>{` script defined, these events are run, otherwise
`}<inlineCode parentName="p">{`stop`}</inlineCode>{` and `}<inlineCode parentName="p">{`start`}</inlineCode>{` are both run if present, including their `}<inlineCode parentName="p">{`pre`}</inlineCode>{` and
`}<inlineCode parentName="p">{`post`}</inlineCode>{` iterations)`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prerestart`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`restart`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postrestart`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-run-script"
      }}><inlineCode parentName="a">{`npm run <user defined>`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`pre<user-defined>`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`<user-defined>`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`post<user-defined>`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-start"
      }}><inlineCode parentName="a">{`npm start`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prestart`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`poststart`}</inlineCode></li>
    </ul>
    <p>{`If there is a `}<inlineCode parentName="p">{`server.js`}</inlineCode>{` file in the root of your package, then npm
will default the `}<inlineCode parentName="p">{`start`}</inlineCode>{` command to `}<inlineCode parentName="p">{`node server.js`}</inlineCode>{`.  `}<inlineCode parentName="p">{`prestart`}</inlineCode>{` and
`}<inlineCode parentName="p">{`poststart`}</inlineCode>{` will still run in this case.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-stop"
      }}><inlineCode parentName="a">{`npm stop`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`prestop`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`stop`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`poststop`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-test"
      }}><inlineCode parentName="a">{`npm test`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`pretest`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`test`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`posttest`}</inlineCode></li>
    </ul>
    <h4><a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-version"
      }}><inlineCode parentName="a">{`npm version`}</inlineCode></a></h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`preversion`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`version`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`postversion`}</inlineCode></li>
    </ul>
    <h4>{`A Note on a lack of `}<a parentName="h4" {...{
        "href": "/cli/v8/commands/npm-uninstall"
      }}><inlineCode parentName="a">{`npm uninstall`}</inlineCode></a>{` scripts`}</h4>
    <p>{`While npm v6 had `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{` lifecycle scripts, npm v7 does not. Removal of a package can happen for a wide variety of reasons, and there's no clear way to currently give the script enough context to be useful. `}</p>
    <p>{`Reasons for a package removal include:`}</p>
    <ul>
      <li parentName="ul">{`a user directly uninstalled this package`}</li>
      <li parentName="ul">{`a user uninstalled a dependant package and so this dependency is being uninstalled`}</li>
      <li parentName="ul">{`a user uninstalled a dependant package but another package also depends on this version`}</li>
      <li parentName="ul">{`this version has been merged as a duplicate with another version`}</li>
      <li parentName="ul">{`etc.`}</li>
    </ul>
    <p>{`Due to the lack of necessary context, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{` lifecycle scripts are not implemented and will not function.`}</p>
    <h3>{`User`}</h3>
    <p>{`When npm is run as root, scripts are always run with the effective uid
and gid of the working directory owner.`}</p>
    <h3>{`Environment`}</h3>
    <p>{`Package scripts run in an environment where many pieces of information
are made available regarding the setup of npm and the current state of
the process.`}</p>
    <h4>{`path`}</h4>
    <p>{`If you depend on modules that define executable scripts, like test
suites, then those executables will be added to the `}<inlineCode parentName="p">{`PATH`}</inlineCode>{` for
executing the scripts.  So, if your package.json has this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name" : "foo",
  "dependencies" : {
    "bar" : "0.1.x"
  },
  "scripts": {
    "start" : "bar ./test"
  }
}
`}</code></pre>
    <p>{`then you could run `}<inlineCode parentName="p">{`npm start`}</inlineCode>{` to execute the `}<inlineCode parentName="p">{`bar`}</inlineCode>{` script, which is
exported into the `}<inlineCode parentName="p">{`node_modules/.bin`}</inlineCode>{` directory on `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`.`}</p>
    <h4>{`package.json vars`}</h4>
    <p>{`The package.json fields are tacked onto the `}<inlineCode parentName="p">{`npm_package_`}</inlineCode>{` prefix. So,
for instance, if you had `}<inlineCode parentName="p">{`{"name":"foo", "version":"1.2.5"}`}</inlineCode>{` in your
package.json file, then your package scripts would have the
`}<inlineCode parentName="p">{`npm_package_name`}</inlineCode>{` environment variable set to "foo", and the
`}<inlineCode parentName="p">{`npm_package_version`}</inlineCode>{` set to "1.2.5".  You can access these variables
in your code with `}<inlineCode parentName="p">{`process.env.npm_package_name`}</inlineCode>{` and
`}<inlineCode parentName="p">{`process.env.npm_package_version`}</inlineCode>{`, and so on for other fields.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-json"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` for more on package configs.`}</p>
    <h4>{`current lifecycle event`}</h4>
    <p>{`Lastly, the `}<inlineCode parentName="p">{`npm_lifecycle_event`}</inlineCode>{` environment variable is set to
whichever stage of the cycle is being executed. So, you could have a
single script used for different parts of the process which switches
based on what's currently happening.`}</p>
    <p>{`Objects are flattened following this format, so if you had
`}<inlineCode parentName="p">{`{"scripts":{"install":"foo.js"}}`}</inlineCode>{` in your package.json, then you'd
see this in the script:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`process.env.npm_package_scripts_install === "foo.js"
`}</code></pre>
    <h3>{`Examples`}</h3>
    <p>{`For example, if your package.json contains this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "scripts" : {
    "install" : "scripts/install.js",
    "postinstall" : "scripts/install.js",
    "uninstall" : "scripts/uninstall.js"
  }
}
`}</code></pre>
    <p>{`then `}<inlineCode parentName="p">{`scripts/install.js`}</inlineCode>{` will be called for the install
and post-install stages of the lifecycle, and `}<inlineCode parentName="p">{`scripts/uninstall.js`}</inlineCode>{`
will be called when the package is uninstalled.  Since
`}<inlineCode parentName="p">{`scripts/install.js`}</inlineCode>{` is running for two different phases, it would
be wise in this case to look at the `}<inlineCode parentName="p">{`npm_lifecycle_event`}</inlineCode>{` environment
variable.`}</p>
    <p>{`If you want to run a make command, you can do so.  This works just
fine:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "scripts" : {
    "preinstall" : "./configure",
    "install" : "make && make install",
    "test" : "make test"
  }
}
`}</code></pre>
    <h3>{`Exiting`}</h3>
    <p>{`Scripts are run by passing the line as a script argument to `}<inlineCode parentName="p">{`sh`}</inlineCode>{`.`}</p>
    <p>{`If the script exits with a code other than 0, then this will abort the
process.`}</p>
    <p>{`Note that these script files don't have to be Node.js or even
JavaScript programs. They just have to be some kind of executable
file.`}</p>
    <h3>{`Best Practices`}</h3>
    <ul>
      <li parentName="ul">{`Don't exit with a non-zero error code unless you `}<em parentName="li">{`really`}</em>{` mean it.
Except for uninstall scripts, this will cause the npm action to
fail, and potentially be rolled back.  If the failure is minor or
only will prevent some optional features, then it's better to just
print a warning and exit successfully.`}</li>
      <li parentName="ul">{`Try not to use scripts to do what npm can do for you.  Read through
`}<a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` to see all the things that you can specify and enable
by simply describing your package appropriately.  In general, this
will lead to a more robust and consistent state.`}</li>
      <li parentName="ul">{`Inspect the env to determine where to put things.  For instance, if
the `}<inlineCode parentName="li">{`npm_config_binroot`}</inlineCode>{` environment variable is set to `}<inlineCode parentName="li">{`/home/user/bin`}</inlineCode>{`, then
don't try to install executables into `}<inlineCode parentName="li">{`/usr/local/bin`}</inlineCode>{`.  The user
probably set it up that way for a reason.`}</li>
      <li parentName="ul">{`Don't prefix your script commands with "sudo".  If root permissions
are required for some reason, then it'll fail with that error, and
the user will sudo the npm command in question.`}</li>
      <li parentName="ul">{`Don't use `}<inlineCode parentName="li">{`install`}</inlineCode>{`. Use a `}<inlineCode parentName="li">{`.gyp`}</inlineCode>{` file for compilation, and `}<inlineCode parentName="li">{`prepare`}</inlineCode>{`
for anything else. You should almost never have to explicitly set a
preinstall or install script. If you are doing this, please consider if
there is another option. The only valid use of `}<inlineCode parentName="li">{`install`}</inlineCode>{` or `}<inlineCode parentName="li">{`preinstall`}</inlineCode>{`
scripts is for compilation which must be done on the target architecture.`}</li>
      <li parentName="ul">{`Scripts are run from the root of the package folder, regardless of what the
current working directory is when `}<inlineCode parentName="li">{`npm`}</inlineCode>{` is invoked. If you want your
script to use different behavior based on what subdirectory you're in, you
can use the `}<inlineCode parentName="li">{`INIT_CWD`}</inlineCode>{` environment variable, which holds the full path you
were in when you ran `}<inlineCode parentName="li">{`npm run`}</inlineCode>{`.`}</li>
    </ul>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/developers"
        }}>{`npm developers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      